<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="save"
    @on-cancel="hide"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
    <v-row v-if="conditionItems.length == 0" justify="center" align="center">
      <v-col cols="1">
        <v-btn
          tile
          color="primary"
          prepend-icon="mdi-plus"
          outlined
          @click="addAction()"
        >
          {{ $t("Add") }}
        </v-btn>
      </v-col>
    </v-row>
    <div v-for="item in conditionItems" :key="item.uuid">
      <SearchCriteriaCondition
        :ref="`searchCriteriaConditionKey${item.uuid}`"
        :fieldList="fieldList"
        :showSearchOperatorSelect="false"
        :showParameterizableValue="true"
        :clearValue="false"
        :conditionItem="item"
        @on-condition-item-add="addAction"
        @on-condition-item-remove="removeAction"
      />
    </div>
  </base-modal>
</template>
<script>
import StateTransitionAction from "@/ecm/models/workflow/StateTransitionAction";
import ConditionItem from "@/ecm/models/search/ConditionItem";
import FieldType from "@/ecm/variables/FieldType";
import SearchService from "@/services/SearchService";
import SearchCriteriaCondition from "@/components/search/SearchCriteriaCondition.vue";
import SearchConstValues from "@/ecm/variables/SearchConstValues";
import ContentTypeService from "@/services/ContentTypeService";

export default {
  name: "ActionsModal",
  components: {
    SearchCriteriaCondition
  },
  props: {
    contentTypeIDs: {
      type: Array,
      default: () => []
    }
  },
  async created() {
    await this.getFields();
  },
  data() {
    return {
      modal: {
        title: this.$t("Actions"),
        key: "actionModalKey"
      },
      open: false,
      conditionItems: [],
      fieldList: []
    };
  },
  methods: {
    async getFields() {
      await SearchService.getAdvSearchFields(this.contentTypeIDs.join()).then(
        data => {
          this.fieldList = data;
        }
      );
    },
    edit(actions) {
      this.conditionItems = [];
      var self = this;
      actions.forEach(item => {
        var fieldType = self.fieldList.find(x => x.Code === item.defFieldCode)
          .Type;
        var conditionStr = `${item.defFieldCode}|s01|${item.value}|${
          FieldType[fieldType]
        }`;
        var conditionItem = new ConditionItem(conditionStr);
        self.setDisplayValue(conditionItem);
        conditionItem.isParameterizable = item.isParameterizable;
        self.conditionItems.push(conditionItem);
      });
      this.show();
    },
    setDisplayValue(conditionItem) {
      if (conditionItem.fieldValue == SearchConstValues.Today) {
        conditionItem.fieldDisplayValue = this.$t("Today");
      } else if (conditionItem.fieldValue == SearchConstValues.Myself) {
        conditionItem.fieldDisplayValue = this.$t("Myself");
      } else if (
        conditionItem.fieldValue == SearchConstValues.Empty ||
        conditionItem.fieldValue == SearchConstValues.NotEmpty
      ) {
        conditionItem.fieldDisplayValue = "";
      } else if (conditionItem.fieldDisplayValue == SearchConstValues.Myself) {
        conditionItem.fieldDisplayValue = this.$t("Myself");
      } else {
        conditionItem.fieldDisplayValue = conditionItem.fieldValue
          .replace(
            SearchConstValues.DaysBeforeToday,
            `${this.$t("DaysBeforeToday")} ${this.$t("Today")}`
          )
          .replace(
            SearchConstValues.DaysAfterToday,
            `${this.$t("DaysAfterToday")} ${this.$t("Today")}`
          );
      }
    },
    async save() {
      var actions = this.conditionItems.filter(f => f.fieldCode).map(x => {
        var action = new StateTransitionAction();
        action.defFieldCode = x.fieldCode;
        action.value = x.fieldValue;
        action.isParameterizable = x.isParameterizable;
        return action;
      });
      var contentTypeFields = await ContentTypeService.getFields(this.contentTypeIDs);
      var uniqueFields = [
        ...new Set(
          contentTypeFields
            .filter(
              (f) => f.IsUnique && actions.some((a) => a.defFieldCode == f.Code)
            )
            .map((f) => f.Name)
        ),
      ];
      if (uniqueFields.length > 0) {
        if (uniqueFields.length > 0) {
          var confirmMessage = this.$t(
            "UniqueFieldsAutomaticActionsWarning"
          ).replaceAll("{0}", uniqueFields.join());

          var res = await this.$confirm(confirmMessage, {
            title: this.$t("Confirm"),
            icon: "mdi-alert",
            color: "warning",
            buttonTrueText: this.$t("Save"),
            buttonFalseText: this.$t("Cancel"),
          });

          if (res != 1) {
            return;
          }
        }
      }
      this.$emit("on-saved", actions);
      this.hide();
    },
    removeAction(item) {
      this.conditionItems = this.conditionItems.filter(
        f => f.uuid != item.uuid
      );
    },
    addAction() {
      this.conditionItems.push(new ConditionItem());
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    }
  }
};
</script>
